import React from 'react'
import { Stack, Typography } from '@mui/material'

export default function BlockTitle({ title, description }) {
  return (
    <Stack rowGap={1}>
      <Typography sx={titleSx}>{title}</Typography>
      {description && <Typography sx={descriptionSx}>{description}</Typography>}
    </Stack>
  )
}
const titleSx = {
  fontFamily: 'Satoshi',
  fontWeight: 900,
  fontSize: '24px',
  color: '#1B1B26'
}

const descriptionSx = {
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  color: '#1B1B26',
  whiteSpace: 'normal',
  wordBreak: 'break-word'
}
